import { Component, ViewEncapsulation } from '@angular/core';
import { CellComponent } from '@spartacus/organization/administration/components';

@Component({
    selector: 'app-uig-checkbox',
    templateUrl: './uig-checkbox.component.html',
    styleUrls: ['./uig-checkbox.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigCheckboxComponent extends CellComponent {

}
